import React from 'react';
import { KeyRound } from 'lucide-react';
import '../../Components/RentableDetail/RentableDetail.css';

/**
 * The discreet "Nycklar" link under a lägenhet/lokal/förråd's sections (after Foton), styled like
 * Tidigare hyresgäster; opens ObjectKeysModal.
 */
const ObjectKeysButton: React.FC<{ onClick: () => void; disabled?: boolean }> = ({ onClick, disabled }) => (
    <div className="rentable-detail-links">
        <button type="button" className="rentable-detail-link" onClick={onClick} disabled={disabled}>
            <KeyRound size={14} aria-hidden="true" />Nycklar
        </button>
    </div>
);

export default ObjectKeysButton;
